import { useEffect, useState } from "react";
import {
  GoogleAuthProvider,
  onAuthStateChanged,
  signInWithPopup,
  signOut as firebaseSignOut,
} from "firebase/auth";

import { auth } from "../firebase";

function useAuth() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!auth) return;
    return onAuthStateChanged(auth, setUser);
  }, []);

  function signIn() {
    if (!auth) return;
    signInWithPopup(auth, new GoogleAuthProvider()).catch((error) => {
      console.warn("Sign-in failed", error);
    });
  }

  function signOut() {
    if (!auth) return;
    firebaseSignOut(auth).catch((error) => {
      console.warn("Sign-out failed", error);
    });
  }

  return { user, signIn, signOut, authEnabled: !!auth };
}

export default useAuth;
